// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__T84kS","AppStretch":"Layout_AppStretch__kDBh3","AppContainer":"Layout_AppContainer__dkaK-"};